document.querySelectorAll('.pdp-hero').forEach(function (section) {
  // Thumbnail -> main image swap
  var mainImg = section.querySelector('[data-pdp-main-img]');
  section.querySelectorAll('[data-pdp-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      section.querySelectorAll('[data-pdp-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (mainImg && thumb.dataset.full) {
        mainImg.src = thumb.dataset.full;
      }
    });
  });

  // Bolts step through the same thumbnail list the rail uses, so both stay in sync.
  var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-pdp-thumb]'));

  function showThumb(index) {
    if (!thumbs.length) return;
    var next = (index + thumbs.length) % thumbs.length;
    thumbs.forEach(function (t) { t.classList.remove('is-active'); });
    thumbs[next].classList.add('is-active');
    if (mainImg && thumbs[next].dataset.full) mainImg.src = thumbs[next].dataset.full;
  }

  function currentIndex() {
    var active = thumbs.indexOf(section.querySelector('[data-pdp-thumb].is-active'));
    return active < 0 ? 0 : active;
  }

  section.querySelectorAll('[data-pdp-gallery-prev]').forEach(function (btn) {
    btn.addEventListener('click', function () { showThumb(currentIndex() - 1); });
  });

  section.querySelectorAll('[data-pdp-gallery-next]').forEach(function (btn) {
    btn.addEventListener('click', function () { showThumb(currentIndex() + 1); });
  });

  // Swipe the main photo left/right on touch screens. A mostly-horizontal
  // swipe of 40px or more changes photo; anything else is left to the page.
  var mainFrame = section.querySelector('.pdp-hero__main');
  if (mainFrame && 'ontouchstart' in window) {
    var startX = 0;
    var startY = 0;
    var tracking = false;
    mainFrame.addEventListener('touchstart', function (event) {
      tracking = event.touches.length === 1;
      if (!tracking) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });
    mainFrame.addEventListener('touchend', function (event) {
      if (!tracking) return;
      tracking = false;
      var touch = event.changedTouches[0];
      var dx = touch.clientX - startX;
      var dy = touch.clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        showThumb(currentIndex() + (dx < 0 ? 1 : -1));
      }
    }, { passive: true });
  }

  // Main frame magnifies under the cursor so the 2% HA callout is readable.
  // Pointer-fine only: there is no hover to leave on a phone.
  var zoomFrame = section.querySelector('[data-pdp-zoom]');
  if (zoomFrame && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    zoomFrame.addEventListener('mouseenter', function () {
      zoomFrame.classList.add('is-zoomed');
    });
    zoomFrame.addEventListener('mouseleave', function () {
      zoomFrame.classList.remove('is-zoomed');
      if (mainImg) mainImg.style.transformOrigin = '';
    });
    zoomFrame.addEventListener('mousemove', function (event) {
      if (!mainImg) return;
      var box = zoomFrame.getBoundingClientRect();
      var x = ((event.clientX - box.left) / box.width) * 100;
      var y = ((event.clientY - box.top) / box.height) * 100;
      mainImg.style.transformOrigin = x + '% ' + y + '%';
    });
  }

  // Pack-size pill selection -> hidden variant id + price display
  var variantIdInput = section.querySelector('[data-pdp-variant-id]');
  var currentPriceEl = section.querySelector('[data-pdp-current-price]');
  var comparePriceEl = section.querySelector('[data-pdp-compare-price]');
  var priceWrap = section.querySelector('[data-pdp-price]');

  function formatMoney(cents) {
    return (Number(cents) / 100).toLocaleString(undefined, { style: 'currency', currency: 'USD' }).replace(/\.00$/, '');
  }

  section.querySelectorAll('[data-pdp-pack-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      section.querySelectorAll('.pdp-hero__pack-pill').forEach(function (pill) { pill.classList.remove('is-active'); });
      input.closest('.pdp-hero__pack-pill').classList.add('is-active');

      if (variantIdInput) variantIdInput.value = input.value;

      // Variant shot takes over the main frame. A variant with no image of its
      // own leaves whatever is showing alone rather than blanking the gallery.
      if (mainImg && input.dataset.media) {
        mainImg.src = input.dataset.media;
        mainImg.dataset.mediaId = input.dataset.mediaId || '';
        var matchedThumb = null;
        thumbs.forEach(function (t) {
          t.classList.remove('is-active');
          if (input.dataset.mediaId && t.dataset.mediaId === input.dataset.mediaId) matchedThumb = t;
        });
        if (matchedThumb) matchedThumb.classList.add('is-active');
      }

      if (currentPriceEl && input.dataset.price) {
        currentPriceEl.textContent = formatMoney(input.dataset.price);
      }
      if (priceWrap) {
        var comparePrice = Number(input.dataset.comparePrice || 0);
        var price = Number(input.dataset.price || 0);
        if (comparePrice > price) {
          if (!comparePriceEl) {
            comparePriceEl = document.createElement('s');
            comparePriceEl.className = 'pdp-hero__price-compare';
            comparePriceEl.setAttribute('data-pdp-compare-price', '');
            priceWrap.insertBefore(comparePriceEl, priceWrap.firstChild);
          }
          comparePriceEl.textContent = formatMoney(comparePrice);
          comparePriceEl.hidden = false;
        } else if (comparePriceEl) {
          comparePriceEl.hidden = true;
        }
      }
    });
  });

  // Accordion rows
  section.querySelectorAll('[data-pdp-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var row = trigger.closest('.pdp-hero__accordion-row');
      var panel = row.querySelector('[data-pdp-accordion-panel]');
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!isOpen));
      trigger.querySelector('.pdp-hero__accordion-icon').textContent = isOpen ? '+' : '-';
      panel.style.maxHeight = isOpen ? '0' : panel.scrollHeight + 'px';
    });
  });

  // Subscribe & save toggle (visual only until a subscription app is installed)
  var subscribeToggle = section.querySelector('[data-pdp-subscribe-toggle]');
  var subscribeNote = section.querySelector('[data-pdp-subscribe-note]');
  if (subscribeToggle && subscribeNote) {
    subscribeToggle.addEventListener('click', function () {
      var isOpen = subscribeToggle.getAttribute('aria-expanded') === 'true';
      subscribeToggle.setAttribute('aria-expanded', String(!isOpen));
      subscribeToggle.classList.toggle('is-active', !isOpen);
      subscribeNote.hidden = isOpen;
    });
  }
});
